import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Chip from "@material-ui/core/Chip";

import { updateCategoryList } from "../../store/actions/appdata";

export default function LocCategorySelector({
  options, //should not be taken from the parent
  value, //should not be taken from the parent
  field,
  form,
  label,
  helperText,
  error,
  ...rest
}) {
  const dispatch = useDispatch();
  const categoryList = useSelector((state) =>
    !!state.appdata.category.list ? state.appdata.category.list : []
  );
  const [categoryArray, setCategoryArray] = useState([]);
  const loadingCategory = categoryArray.length === 0;

  useEffect(() => {
    if (categoryList.length === 0) {
      dispatch(updateCategoryList());
    } else {
      const list = [];
      categoryList.forEach((cat) => {
        !!cat.subCat &&
          cat.subCat.length > 0 &&
          cat.subCat.forEach((subCat) => {
            list.push({
              categoryId: cat.id,
              categoryName: cat.name,
              subCategoryId: subCat.id,
              subCategoryName: subCat.name,
              categoryColor: cat.color,
            });
          });
      });
      setCategoryArray(_.orderBy(list, ["categoryName", "subCategoryName"]));
    }
  }, [categoryList, dispatch]);

  return (
    <Autocomplete
      id="location-category-selector"
      name={field.name}
      value={
        categoryArray.length > 0 && field.value && field.value.length > 0
          ? field.value.map((val) => {
              return categoryArray.find((cat) => {
                return cat.subCategoryId === val;
              });
            })
          : []
      }
      multiple
      filterSelectedOptions
      options={categoryArray}
      getOptionLabel={(option) =>
        `${option.categoryName} : ${option.subCategoryName}`
      }
      renderOption={(option) => option.subCategoryName}
      groupBy={(option) => option.categoryName}
      fullWidth
      loading={loadingCategory}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          helperText={helperText}
          error={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loadingCategory ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          return (
            <Chip
              variant="outlined"
              style={{ backgroundColor: option.categoryColor || "#616161" }}
              label={`${option.categoryName} : ${option.subCategoryName}`}
              {...getTagProps({ index })}
            />
          );
        })
      }
      onChange={(e, value) => {
        form.setFieldValue(
          field.name,
          value && value.length > 0
            ? value.map((item) => {
                return item.subCategoryId;
              })
            : []
        );
      }}
      {...rest}
    />
  );
}
